/* tslint:disable:no-access-missing-member */

import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
export class FormlyFieldWysiwygComponent extends FieldType implements OnInit {
public toolbars = {
    default: {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['clean'],
        ['link'],
      ],
    },
    full: {
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        ['blockquote', 'code-block'],

        [{ header: 1 }, { header: 2 }], // custom button values
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
        [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
        [{ direction: 'rtl' }], // text direction

        [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
        [{ header: [1, 2, 3, 4, 5, 6, false] }],

        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        [{ font: [] }],
        [{ align: [] }],

        ['clean'], // remove formatting button

        ['link', 'image', 'video'], // link and image, video
      ],
    },
    basic: {
      toolbar: true,
    },
  }
public toolbar = this.toolbars.basic
public theme = 'snow'
/**
 * @return {?}
 */
ngOnInit() {
    this.toolbar = this.toolbars[this.to['toolbar']] || this.toolbars.default
    this.theme = this.to['theme'] || this.theme
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ngx-formly-field-wysiwyg',
  template: `
    <ngx-quill-editor [formlyAttributes]="field"
                  [(ngModel)]="model[key]"
                  [theme]="theme"
                  [modules]="toolbar">
    </ngx-quill-editor>
  `,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function FormlyFieldWysiwygComponent_tsickle_Closure_declarations() {
/** @type {?} */
FormlyFieldWysiwygComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FormlyFieldWysiwygComponent.ctorParameters;
/** @type {?} */
FormlyFieldWysiwygComponent.prototype.toolbars;
/** @type {?} */
FormlyFieldWysiwygComponent.prototype.toolbar;
/** @type {?} */
FormlyFieldWysiwygComponent.prototype.theme;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
